import React from "react";

const SvgEmptyMarkerA2 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 26" ref={svgRef} {...props} width="1em" height="1em">
    <title>{title}</title>
    <path
      d="M9.1.4C4.3.4.5 4.4.5 9.2c0 6.6 8.6 16.4 8.6 16.4s8.6-9.8 8.6-16.4C17.8 4.4 13.9.4 9.1.4"
      fill="#2fa0a0"
    />
    <path
      d="M11.7 15.7l-.6-1.9H7l-.6 1.9H3.5L7.4 4.4h3.3l3.9 11.3h-2.9zm-4-4h2.7l-1.3-4-1.4 4z"
      fill="#fff"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgEmptyMarkerA2 svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/EmptyMarkerA2.js